import React from "react";
import { motion } from "framer-motion";

const pillars = [
  {
    num: "1",
    title: "ENGINEERING\nCOMFORT",
    tag: "Technical precision in everything we build",
    desc: "Every system we design is grounded in engineering science. We size accurately, select precisely, and install to specification — so the comfort we create performs flawlessly from day one and endures for years beyond.",
  },
  {
    num: "2",
    title: "DELIVERING\nEXCELLENCE",
    tag: "Our baseline standard — not our aspiration",
    desc: "Excellent service is not a target at SMARTCOOL — it is our minimum. Every project, every maintenance visit, and every client interaction is held to the same uncompromising standard: on time, on spec, and beyond expectation.",
  },
  {
    num: "3",
    title: "BUILDING\nPARTNERSHIP",
    tag: "Lasting partnership, enduring comfort",
    desc: "We build more than HVAC systems. We build lasting comfort — physical, operational, and relational. Long after installation, SMARTCOOL remains your partner: maintaining systems, renewing contracts, and ensuring comfort endures.",
  },
];

export default function BrandPillars() {
  return (
    <section className="bg-gray-100 py-10 sm:py-16 font-poppins">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">

        {/* Title — drops in from top */}
        <motion.div
          className="flex justify-center mb-8 sm:mb-10"
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.6 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <h2
            className="text-lg sm:text-4xl rounded-md font-extrabold text-white px-6 sm:px-12 py-3 tracking-widest text-center"
            style={{ backgroundColor: "#0F1030" }}
          >
            OUR THREE BRAND PILLARS
          </h2>
        </motion.div>

        {/* Cards — each slides up one by one with stagger */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {pillars.map((p, i) => (
            <motion.div
              key={p.num}
              className="flex flex-col"
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 0.6, ease: "easeOut", delay: i * 0.2 }}
            >
              {/* Top navy */}
              <div
                className="flex flex-col items-center justify-center py-6 sm:py-8 px-4 text-center"
                style={{ backgroundColor: "#0F1030" }}
              >
                <span
                  className="font-anton leading-none mb-3"
                  style={{ color: "#00C7EF", fontSize: "60px" }}
                >
                  {p.num}
                </span>
                <h3
                  className="font-extrabold text-base sm:text-lg tracking-wide whitespace-pre-line"
                  style={{ color: "#00C7EF" }}
                >
                  {p.title}
                </h3>
              </div>
              {/* Cyan tagline */}
              <div
                className="px-4 py-3 text-xs sm:text-sm font-semibold"
                style={{ backgroundColor: "#00C7EF", color: "#0F1030" }}
              >
                {p.tag}
              </div>
              {/* Body */}
              <div className="bg-white px-4 py-5 sm:py-6 flex-1">
                <p className="text-gray-700 text-xs sm:text-sm leading-relaxed">{p.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}